module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    if (letter === ' ') return letter;
    switch (i%3) {
      case 0: return colors.red(letter);
      case 1: return colors.white(letter);
      case 2: return colors.blue(letter);
    }
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/colors/lib/maps/america.js
// module id = DWkb
// module chunks = 0